import { AuthProviderContextV2 } from "./auth-provider-v2";
import { RoutesProviderContext } from "./routes-provider";
import { useContext } from "react";
import type { RoutesProviderValue } from './routes-provider.types';
import type { AuthProviderValue } from './auth-provider.types';

/**
 * Hook to access auth provider context
 */
export const useAuthProviderV2 = (): AuthProviderValue => {
    const context = useContext(AuthProviderContextV2);
    if (!context) throw new Error("useAuthProviderV2 must be used within the AuthProviderV2.");
    return context;
};

/**
 * Hook to access routes provider context
 */
export const useRoutesProvider = (): RoutesProviderValue => {
    const context = useContext(RoutesProviderContext);
    if (!context) throw new Error("useRoutesProvider must be used within the RoutesProvider.");
    return context;
};
